import { Component, OnDestroy, OnInit } from '@angular/core';
import { LoggingService, SignalRHub } from '@fgb/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'fgb-master-page',
  templateUrl: './master-page.component.html',
  styleUrls: ['./master-page.component.scss'],
})
export class MasterPageComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();

  constructor(
    private signalRHub: SignalRHub,
    private logService: LoggingService
  ) {}

  ngOnInit() {
    this.signalRHub.connectionEstablished$.pipe(takeUntil(this._destroyed$)).subscribe((connection) => {
      this.logService.debug('SignalR connection', connection);
    });
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
